const classPrefix = 'main-brands';
const dataAttr = 'data-main-brands';
const $container = document.querySelector(`[${dataAttr}]`)

if ($container) {
    mainBrands()
}

export function mainBrands() {

    init();

    function init() {
        document.addEventListener('DOMContentLoaded', () => {
            initSmoothCarousel({
                selector: '[data-main-brands]',
                speedPxPerSec: 60,    // подстройте под желаемую «быстроту»
                pauseOnHover: true
            });
        });
    }
}

export function initSmoothCarousel({
                                       selector = '[data-main-brands]',
                                       speedPxPerSec = 100,      // скорость в пикселях в секунду
                                       pauseOnHover = true
                                   } = {}) {
    const root = document.querySelector(selector);
    if (!root) return;

    const track = root.querySelector('.main-brands__carousel-track');
    let animationId = null;
    let pos = 0;
    let trackWidth = track.scrollWidth / 2;
    let lastTimestamp = null;

    // Включаем GPU-ускорение
    track.style.willChange = 'transform';

    // Главное анимированное луп-функция
    function animate(timestamp) {
        if (lastTimestamp === null) lastTimestamp = timestamp;
        const delta = timestamp - lastTimestamp;
        lastTimestamp = timestamp;

        // переводим скорость в пикс/кадр
        pos -= (speedPxPerSec * delta) / 1000;

        // если вышли за предел — сбрасываем остаток, чтобы не прыгало
        if (Math.abs(pos) >= trackWidth) {
            pos = pos % trackWidth;
        }

        track.style.transform = `translate3d(${pos}px, 0, 0)`;
        animationId = requestAnimationFrame(animate);
    }

    // Старт анимации
    animationId = requestAnimationFrame(animate);

    // Пауза по наведению
    if (pauseOnHover) {
        root.addEventListener('mouseenter', () => {
            if (animationId) cancelAnimationFrame(animationId);
            lastTimestamp = null;
        });
        root.addEventListener('mouseleave', () => {
            // сброс lastTimestamp, чтобы не «залипал» большой delta
            animationId = requestAnimationFrame(animate);
        });
    }

    // Пересчет ширины при изменении размера окна
    window.addEventListener('resize', () => {
        trackWidth = track.scrollWidth / 2;
        // корректируем pos, чтобы остаться в [0, trackWidth)
        pos = pos % trackWidth;
    });
}
